import React, { memo } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router';

import CustomBtn from '../../../../generic/CustomBtn';

const ProjectHeader = ({ name, projectId }) => {
  const history = useHistory();
  const translate = useIntl();

  return (
    <div className="project__header">
      <CustomBtn
        label={translate.formatMessage({ id: 'projectPage.buttonBack.title' })}
        customClass="btn__back"
        iconClass="icon-arrow-pointer-alt"
        type="button"
        handleClick={() => history.push('/')}
      />
      {name && (
      <span className="header-name overflow-scroll">
        <strong>{name}</strong>
        <br />
        {translate.formatMessage({ id: 'project-id' })}
        {projectId}
      </span>
      )}
      <div />
    </div>
  );
};

export default memo(ProjectHeader);
